// Disabled — swipe-tab gesture and animation are temporarily turned off.
// Re-enable by restoring the full implementation from git history.
// All call sites are preserved so re-enabling requires only this file + CustomTabs.tsx.

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useSwipeTab(
  _value: number,
  _tabs: number | number[],
  _onChange: (newValue: number) => void,
): void {
  // no-op
}
